// JWT token storage. "Remember me" -> localStorage (persists across restarts);
// otherwise sessionStorage (cleared when the tab/app closes). Both are synchronous
// and work in the web browser and the Capacitor native WebView.
const AK = "rc_access_token";
const RK = "rc_refresh_token";

const read = (k) => {
  try { return localStorage.getItem(k) || sessionStorage.getItem(k); } catch { return null; }
};

export const getToken = () => read(AK);
export const getRefreshToken = () => read(RK);

export function setTokens({ access_token, refresh_token, remember }) {
  try {
    clearToken();
    const store = remember ? localStorage : sessionStorage;
    if (access_token) store.setItem(AK, access_token);
    if (refresh_token) store.setItem(RK, refresh_token);
  } catch (e) { console.debug("setTokens: storage unavailable", e); }
}

// Update just the access token after a silent refresh, keeping the same storage bucket.
export function setAccessToken(t) {
  try {
    if (!t) return;
    const store = localStorage.getItem(RK) != null ? localStorage : sessionStorage;
    store.setItem(AK, t);
  } catch (e) { console.debug("setAccessToken: storage unavailable", e); }
}

export function clearToken() {
  try {
    [localStorage, sessionStorage].forEach((s) => { s.removeItem(AK); s.removeItem(RK); });
  } catch (e) { console.debug("clearToken: storage unavailable", e); }
}
